import React from 'react';
import './Cayala.css';

const Cayala: React.FC = () => {
  return (
    <div className="cayala-page">
      <div className="cayala-container">
        <div className="cayala-content">
            <div className="cayala-text-content">
              <img 
                src="/img/cayala/cayala-logo.png" 
                alt="Cayalá" 
                className="cayala-title"
              />
              
              <div className="cayala-description">
                <p className="cayala-main-text">
                  Ciudad Cayalá, una ciudad urbanista pensada para las  <br/>  personas. Con espacios abiertos y seguroS. se ha destacado como un referente arquitectónico en Guatemala.
                </p>
                
                <p className="cayala-secondary-text">
                  Es el lugar donde encuentra calidad de vida y espacios <br/> inspiradores para vivir, trabajar y disfrutar.
                </p>
                        
                <div className="cayala-bottom-section">
                  <img 
                    src="/img/cayala/bottom-image-cayala.png" 
                    alt="Cayalá Bottom View" 
                    className="cayala-bottom-image"
                  />
                </div>
              </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Cayala;
